import React, { useState } from 'react';
import ContextHelp from './ContextHelp';
import CoberturaDetalleModal from './CoberturaDetalleModal';
import Button from '../../common/Button';
import {
  COBERTURA_ROW_STYLES,
  HELP_COBERTURA
} from '../../../utils/finanzasUi';

export default function CoberturaFinancieraCard({
  cobertura,
  compact = false,
  showVerDetalle = true
}) {
  const [modalOpen, setModalOpen] = useState(false);

  if (!cobertura) return null;

  const titleClass = compact ? 'text-xs font-medium text-e0e3-muted' : 'text-sm font-medium text-e0e3-muted';
  const rowClass = compact ? 'text-sm' : 'text-sm';
  const padClass = compact ? 'p-5' : 'p-5 lg:p-6';

  return (
    <>
      <div className={`rounded-xl border border-e0e3-border/40 bg-e0e3-surface/40 ${padClass} min-h-[7rem] flex flex-col justify-center`}>
        <p className={`${titleClass} flex items-center gap-1.5`}>
          Cobertura financiera
          <ContextHelp text={HELP_COBERTURA} label="Ayuda sobre cobertura financiera" />
        </p>
        <div className={`mt-2 space-y-1 ${rowClass}`}>
          <p>
            Real:{' '}
            <span className={`font-semibold ${COBERTURA_ROW_STYLES.real}`}>
              {cobertura.pct_real ?? 0} %
            </span>
          </p>
          <p>
            Estimada:{' '}
            <span className={`font-semibold ${COBERTURA_ROW_STYLES.estimada}`}>
              {cobertura.pct_estimada ?? 0} %
            </span>
          </p>
          <p>
            No calculable:{' '}
            <span className={`font-semibold ${COBERTURA_ROW_STYLES.no_calculable}`}>
              {cobertura.pct_no_calculable ?? 0} %
            </span>
          </p>
        </div>
        {showVerDetalle && (
          <div className="mt-3">
            <Button
              type="button"
              color="secondary"
              size="sm"
              onClick={() => setModalOpen(true)}
            >
              Ver detalle
            </Button>
          </div>
        )}
      </div>
      {showVerDetalle && modalOpen && (
        <CoberturaDetalleModal
          isOpen
          onClose={() => setModalOpen(false)}
          cobertura={cobertura}
        />
      )}
    </>
  );
}
